export default __webpack_public_path__ + "static/media/cashup.cb0ce0fa.gif";